export class Constants {
  static defaultPageSize = 10;

  static all = 'All';
  static groupAll = 'ALL';
  static NA = 'N/A';
  static hyphen = '-';
  static jpegBase64Preffix = 'data:image/jpeg;base64,';
  static dayOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  static monthsOfYear = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  static cachingHeaderMaxAgeKey = 'PW-Caching-Header-Max-Age';
}
